/**
 * Sets cursor / caret position in the editor.
 * @param {*} editor
 * @param {Element} element
 * @param {Boolean} start - Denotes if caret/cursor should appear at the beginning of the element, or the end
 */
export const setCaretPosition = (editor, element, start) => {
  editor.selection.select(element);
  editor.selection.collapse(start);
};
